import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { NavLink } from 'react-router-dom';
import { decodeData } from '../../Constants/constants';
class ShifteList extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);

        var days = [
            { day: 'Monday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Tuesday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Wednesday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Thursday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Friday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Saturday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Sunday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } }
        ]
        this.state = {
            company_location_shift_id: 0,
            location_id: '',
            company_location_shift_code: '',
            company_location_shift_name: '',
            company_location_shift_in_time: '',
            company_location_shift_out_time: '',
            company_location_shift_duration: '',
            ot_max_hr_limit: 0,
            days: days,
            rows: [],
            errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            location_row: [],
            add_shift_rows: [],
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            infoLoading: false,
            info: [],
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
        let newState = { [name]: value };

        if (name === 'company_location_shift_name') {
            const code = value.split(' ').reduce((acc, word) => acc + word.charAt(0), '');
            newState['company_location_shift_code'] = code.toUpperCase();
        }

        this.setState(newState, () => {
            // If the change is related to either in time or out time, calculate duration.
            if (name === 'company_location_shift_in_time' || name === 'company_location_shift_out_time') {
                this.calculateDuration();
            }
        });
    };

    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetShiftInfo?company_location_shift_id=${this.state.company_location_shift_id}`, { headers }).then((response) => {
            const { data, success, days } = response.data;
            if (success === true) {
                this.setState(
                    {
                        location_id: data[0]?.location_id,
                        company_location_shift_code: data[0].company_location_shift_code,
                        company_location_shift_name: data[0].company_location_shift_name,
                        infoLoading: false,
                        info: response.data,
                        add_shift_rows: response.data.breakresults,
                    }, (prevState) => {

                    }
                )
                var re_days = [];
                for (var d = 0; d < days.length; d++) {
                    var day = { day: days[d].shift_day, start_time: days[d].shift_start_time, start_time_grace_period: days[d].shift_start_time_grace_period, end_time: days[d].shift_end_time, end_time_grace_period: days[d].shift_end_time_grace_period, ot_max_hr_limit: days[d].ot_max_hr_limit, week_off: days[d].shift_week_off, week_off_weeks: { week_1: days[d].shift_weekoff_week_1, week_2: days[d].shift_weekoff_week_2, week_3: days[d].shift_weekoff_week_3, week_4: days[d].shift_weekoff_week_4, week_5: days[d].shift_weekoff_week_5 } };
                    re_days.push(day);
                }
                this.setState({
                    days: re_days
                })
            } else {
                this.setState({ infoLoading: false });
            }
        });
    }


    GetList = async () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetShifts`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {

            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        }).catch(function (error) {
            console.log("error", error);
        });


    }

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    company_location_shift_id: id
                };
                axios
                    .post(`${apiURL}Masters/DeleteShift`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    convertTo12HourFormat(time24) {
        const [hours, minutes] = time24.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 >= 12) {
            period = 'PM';
            if (hours12 > 12) {
                hours12 -= 12;
            }
        }

        return `${hours12}:${minutes} ${period}`;
    }

    render() {
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Shifts Master`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Shifts Scheduler</h4>
                                        { this.state.decodedData?.includes(2) && (
                                        <NavLink to={'/Shiftes'} className="btn btn-success" > Add Shift </NavLink >)}
                                    </div>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th width={`55%`}>Shift Name</th>
                                                    <th width={`30%`}>Shift code</th>
                                                    { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={`15%`} className=' text-center'>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.company_location_shift_id}>
                                                            <td>{row.company_location_shift_name}</td>
                                                            <td>{row.company_location_shift_code}</td>
                                                            { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(1) && ( 
                                                                <button onClick={() => this.setState({ company_location_shift_id: row.company_location_shift_id, infoLoading: true }, () => { this.GetInfo() })} className="btn-icon btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="ri-file-info-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(3) && ( 
                                                                <NavLink to={`/Shiftes/${row.company_location_shift_id}`} type='button' className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </NavLink>)}
                                                                { this.state.decodedData?.includes(4) && ( 
                                                                <button onClick={() => this.handleDelete(row.company_location_shift_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={8} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div id="myModal" className="modal fade" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true" style={{ display: 'none' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myModalLabel">Shift Schedule</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
                            </div>
                            <div className="modal-body">

                                {
                                    this.state.info?.days ?
                                        <div>
                                            <h5 className="fs-15">
                                                {this.state.info?.data[0].company_location_shift_name}
                                            </h5>
                                            <table className='table table-bordered table-stripped'>
                                                <thead>
                                                    <tr>
                                                        <th>Day</th>
                                                        <th>Start Time</th>
                                                        {/* <th>Grace Time</th> */}
                                                        <th>End Time</th>
                                                        {/* <th>Grace Time</th> */}
                                                    </tr>
                                                </thead>

                                                {
                                                    this.state.info?.days?.map((day) => {

                                                        return <tbody>
                                                            {
                                                                day.shift_week_off === 0 ?
                                                                    <tr>
                                                                        <td>{day.shift_day}</td>
                                                                        <td>{this.convertTo12HourFormat(day.shift_start_time)} </td>
                                                                        {/* <td>{day.shift_start_time_grace_period} mints</td> */}
                                                                        <td>{this.convertTo12HourFormat(day.shift_end_time)}</td>
                                                                        {/* <td>{day.shift_end_time_grace_period} mints</td> */}
                                                                    </tr> : <div></div>
                                                            }
                                                            {
                                                                day.shift_week_off === 1 ?

                                                                    <tr className='table-warning'>
                                                                        <th>Week off {day.shift_day}</th>
                                                                        <th colSpan={5}>
                                                                            {day.shift_weekoff_week_1 === 1 ? <span className='badge bg-warning'>Week 1</span> : ''} {" "} {" "}
                                                                            {day.shift_weekoff_week_2 === 1 ? <span className='badge bg-warning'>Week 2</span> : ''} {" "} {" "}
                                                                            {day.shift_weekoff_week_3 === 1 ? <span className='badge bg-warning'>Week 3</span> : ''} {" "} {" "}
                                                                            {day.shift_weekoff_week_4 === 1 ? <span className='badge bg-warning'>Week 4</span> : ''} {" "} {" "}
                                                                            {day.shift_weekoff_week_5 === 1 ? <span className='badge bg-warning'>Week 5</span> : ''} {" "} {" "}
                                                                        </th>
                                                                    </tr>
                                                                    : <div></div>}
                                                        </tbody>
                                                    })
                                                }
                                            </table></div> : <div></div>
                                }

                                <h5 className="fs-15">Breaks</h5>
                                <table className={`table table-bordered table-hover mt-3`}>
                                    <thead className='table-light'>
                                        <tr>
                                            <th width={200}>Break name</th>
                                            <th width={200}>Break start time</th>
                                            <th width={200}>Break end time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.add_shift_rows.map((row, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{row.break_name}</td>
                                                        <td>{this.convertTo12HourFormat(row.break_start_time)}</td>
                                                        <td>{this.convertTo12HourFormat(row.break_end_time)}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(ShifteList);